import { z } from "zod";

export const sectionItemTypeEnum = z.enum([
  "small",
  "medium",
  "large",
  "moodcheck",
  "daily_quote",
  "trivia",
  "trivia_leaderboard",
  "hallow_plus_banner",
  "create_group",
  "invite_to_group",
  "alerts",
  "prayer_goal_row",
  "prayer_goal",
  "suggested_routine",
  "deeplink_card",
  "deeplink_card_condensed",
  "deeplink_card_medium",
  "deeplink_card_small",
  "deeplink_card_playable",
  "player_card",
  "player_card_with_header",
  "campaign",
  "create_campaign_prompt",
  "create_campaign_prompt_v2_final",
  "magisterium_prompt",
  "streak", // streak section on me page
  "text_summary", // intentions and reflections sections on me page
  "games",
  "the_word",
  "text_first_content", // daily readings, reflections, saint, Hallow, order of Mass
  "community_intention_small",
  "community_intention_medium",
  "large_with_header",
  "medium_with_header",
  "assignment",
  "routine_item",
  "empty",
  "user_generated_text",
  "categories_game",
  "ai_sample_prompts",
  "banner",
  "streak_goal",
]);

export type SectionItemType = z.infer<typeof sectionItemTypeEnum>;
